import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPalette, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { LANGUAGE } from "services/general";

/**
 * MoreToolsSettingsRow — Settings + language-switch buttons at the bottom of
 * the phone drawer.
 */
const MoreToolsSettingsRow = ({ isDark, onSettings, onChangeLanguage }) => {
  const { t } = useTranslation();

  return (
    <div className="pt-2 flex gap-2.5">
      <button
        type="button"
        onClick={onSettings}
        className={`flex-1 py-3 px-4 rounded-xl flex items-center justify-center gap-2 border text-xs font-semibold transition-colors cursor-pointer ${
          isDark
            ? "bg-white/[0.04] border-white/[0.08] hover:bg-white/[0.08] text-white"
            : "bg-[#F9FAFB] border-gray-100 hover:bg-gray-100 text-heading"
        }`}
      >
        <FontAwesomeIcon icon={faPalette} className="text-sm text-primary" />
        <span>{t("pages.settings") || "المظهر والإعدادات"}</span>
      </button>

      <button
        type="button"
        onClick={onChangeLanguage}
        className={`flex-1 py-3 px-4 rounded-xl flex items-center justify-center gap-2 border text-xs font-semibold transition-colors cursor-pointer ${
          isDark
            ? "bg-white/[0.04] border-white/[0.08] hover:bg-white/[0.08] text-white"
            : "bg-[#F9FAFB] border-gray-100 hover:bg-gray-100 text-heading"
        }`}
      >
        <FontAwesomeIcon icon={faGlobe} className="text-sm text-primary" />
        <span>{LANGUAGE === "ar" ? "English" : "العربية"}</span>
      </button>
    </div>
  );
};

export default MoreToolsSettingsRow;
